import { Charts, Decoration3 } from '@jiaminghi/data-view-react'
import React, { useContext } from 'react'
import { DataContext } from '../../../App'
import useWindowDimensions from '../../hook/window'
import Title from '../../xyfy/title'

export default props => {
  const { height, width } = useWindowDimensions()
  let colors = [
    '#1f77b4',
    '#aec7e8',
    '#ff7f0e',
    '#ffbb78',
    '#2ca02c',
    '#98df8a',
    '#d62728',
    '#ff9896',
    '#9467bd',
    '#c5b0d5',
    '#8c564b',
    '#c49c94',
    '#e377c2',
    '#f7b6d2',
    '#7f7f7f',
    '#c7c7c7',
    '#bcbd22',
    '#dbdb8d',
    '#17becf',
    '#9edae5',
  ]
  let getColor = function(index) {
    try {
      if (colors[index]) {
        return colors[index]
      }
      return '#ffffff'
    } catch (e) {
      console.log(e)
    }
    return '#ffffff'
  }
  let data = useContext(DataContext)
  let scan_data = []
  if (data && data.operations_counter) {
    scan_data = data.operations_counter
  }
  let people_data = {}
  let date_arr = []
  let max_num = 0
  scan_data.forEach(item => {
    if (people_data.hasOwnProperty(item.operator)) {
      people_data[item.operator][item.creation_datetime__date] = item.count
    } else {
      people_data[item.operator] = {
        [item.creation_datetime__date]: item.count,
      }
    }
    if (!date_arr.includes(item.creation_datetime__date)) {
      date_arr.push(item.creation_datetime__date)
    }
    if (item.count > max_num) {
      max_num = item.count
    }
  })

  // 1. 计算每个人的总扫描数
  const peopleWithTotals = Object.entries(people_data).map(([name, dates]) => {
    const total = Object.values(dates).reduce((sum, count) => sum + count, 0)
    return { name, total, details: dates }
  })

  // 2. 按总扫描数降序排序
  peopleWithTotals.sort((a, b) => b.total - a.total)

  // 3. 取前10名
  const top10 = peopleWithTotals.slice(0, 10)

  // 4. 转换回原始格式
  const result = {}
  top10.forEach(person => {
    result[person.name] = person.details
  })

  people_data = result

  // 填充日期
  let finalDate = []
  try {
    date_arr.sort((a, b) => {
      return new Date(a) - new Date(b)
    })
    if (date_arr.length >= 2) {
      let startDate = date_arr[0]
      let endDate = date_arr[date_arr.length - 1]
      let dateMove = new Date(startDate)
      let strDate = startDate

      while (strDate < endDate) {
        strDate = dateMove.toISOString().slice(0, 10)
        finalDate.push(strDate)
        dateMove.setDate(dateMove.getDate() + 1)
      }
    } else {
      finalDate = date_arr
    }
  } catch (e) {
    console.log(e)
    finalDate = date_arr
  }
  for (let key in people_data) {
    finalDate.forEach(item => {
      if (!people_data[key].hasOwnProperty(item)) {
        people_data[key][item] = 0
      }
    })
  }
  let legend_data = []
  let series_data = []
  let index = 0
  for (let key in people_data) {
    legend_data.push({
      name: key,
      color: getColor(index * 2),
    })
    series_data.push({
      name: key,
      data: finalDate.map(item => {
        return people_data[key][item]
      }),
      type: 'line',
      // smooth: true,
      lineStyle: {
        stroke: getColor(index * 2),
      },
      lineArea: {
        show: true,
        gradient: [getColor(index * 2), getColor(index * 2 + 1)],
      },
      linePoint: {
        radius: 4,
        style: {
          fill: getColor(index * 2),
          stroke: 'transparent',
        },
      },
    })
    index += 1
  }
  let option = {
    grid: {
      left: 0.04 * width,
      top: 0.05 * height,
      right: 0.03 * width,
      bottom: 0.07 * height,
      containLabel: true,
    },
    legend: {
      data: legend_data,
      textStyle: {
        fill: '#fff',
        fontSize: 18,
      },
    },
    xAxis: {
      name: '',
      nameTextStyle: {
        fill: '#FFF',
      },
      data: finalDate,
      axisLine: {
        style: {
          stroke: 'rgba(255, 255, 255, 0.3)',
          fontSize: 12,
        },
      },
      axisLabel: {
        style: {
          fill: '#FFF',
          fontSize: 12,
        },
        formatter: function(x) {
          return String(x.value).replace(String(x.value).split('-')[0] + '-', '')
        },
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      name: '扫描数',
      splitLine: {
        style: {
          stroke: 'rgba(255, 255, 255, 0.3)',
        },
        show: true,
      },
      nameTextStyle: {
        fill: '#FFF',
        fontSize: 18,
      },
      data: 'value',
      axisLine: {
        style: {
          stroke: 'rgba(255, 255, 255, 0.3)',
          fontSize: 15,
        },
      },
      axisLabel: {
        style: {
          fill: '#FFF',
          fontSize: 18,
        },
      },
      axisTick: {
        show: false,
      },
      min: 0,
      max: Math.ceil(max_num / 10) * 10,
    },
    series: series_data,
  }
  return (
    <div className="scanLine-container">
      <Title title={'扫描量统计'} image={'/img/10/expire.png'} />
      <Charts
        style={{
          height: height * 0.3,
          width: width * 0.5,
        }}
        option={option}
      />
    </div>
  )
}
